const e = {
  name: "Flexible",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h10v2H3.4l9,9h15.2l9-9H30V0h10v10h-2V3.4l-9,9v15.2l9,9V30h2v10H30v-2h6.6l-9-9H12.4l-9,9H10v2H0V30h2
			v6.6l9-9V12.4l-9-9V10H0V0z M13,13v14h14V13H13z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Flexible
};
